import React, { useCallback, useRef } from 'react';
import { Badge } from '@/components/ui/badge';
import { Upload, FileImage, FileText, FileSpreadsheet } from 'lucide-react';

export function ImportUploadZone({ onFile }) {
  const fileInputRef = useRef(null);
  const [dragActive, setDragActive] = React.useState(false);

  const handleDrag = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(e.type === 'dragenter' || e.type === 'dragover');
  }, []);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files?.[0]) onFile(e.dataTransfer.files[0]);
  }, [onFile]);

  return (
    <div
      className={`border-2 border-dashed rounded-xl p-8 text-center transition-colors ${dragActive ? 'border-primary bg-primary/5' : 'border-border/50 hover:border-primary/50'}`}
      onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}
      data-testid="upload-dropzone"
    >
      <input ref={fileInputRef} type="file" accept=".png,.jpg,.jpeg,.webp,.pdf,.xlsx,.xls" onChange={e => e.target.files?.[0] && onFile(e.target.files[0])} className="hidden" />
      <div className="flex flex-col items-center gap-4">
        <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
          <Upload className="w-8 h-8 text-primary" />
        </div>
        <div>
          <p className="text-lg font-medium">Drop your report or spreadsheet here</p>
          <p className="text-sm text-muted-foreground mt-1">
            or <button onClick={() => fileInputRef.current?.click()} className="text-primary hover:underline">browse files</button>
          </p>
        </div>
        <div className="flex gap-2 mt-2 flex-wrap justify-center">
          <Badge variant="outline" className="gap-1"><FileImage className="w-3 h-3" /> PNG</Badge>
          <Badge variant="outline" className="gap-1"><FileImage className="w-3 h-3" /> JPEG</Badge>
          <Badge variant="outline" className="gap-1"><FileText className="w-3 h-3" /> PDF</Badge>
          <Badge variant="outline" className="gap-1"><FileSpreadsheet className="w-3 h-3" /> Excel</Badge>
        </div>
        <p className="text-xs text-muted-foreground">Max file size: 10MB</p>
      </div>
    </div>
  );
}
